import React from 'react';
import Styles from './styles.module.css';
import DefaultDesc from '../desc';

type DefaultCheckBox = {
  error: boolean;
  title: string;
  list: string[];
  value: string[];
  setValue: (value: string[]) => void;
  desc?: string;
};

const DefaultCheckBox: React.FC<DefaultCheckBox> = ({ error, title, list, value, setValue, desc }) => {

  return (
    <>
    <div className={Styles.title}>
      <p className={Styles.title_text} style={error ? { color: "#E31C5F" } : {}}>{title}</p>
    </div>
    <div className={Styles.check}>
      {list.map((data, index) =>
        <div>
          <input placeholder='' type='checkbox' checked={value.includes(data)} style={{ backgroundColor: "#E31C5F" }}
            onChange={(e) => {
              e.target.checked ? setValue([...value, data]) : setValue(value.filter((v, index) => (v !== data)))
            }}/>
          <p>{data}</p>
        </div>
      )}
    </div>
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultCheckBox;
